export const InternalRoles = ["Administrator", "Trainee", "Marketing", "Comercial", "Internal", "Consultant", "Transformer"];

export const ExternalRoles = ["HumanResources", "TechnicianLimited", "Technician", "Dossie", "Financial", "Master"];